import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/icons/icon-line-under-title.png'


const _hoisted_1 = { class: "memorial-text" }
const _hoisted_2 = {
  key: 0,
  ref: "textContainer",
  class: "memorial-text__content"
}
const _hoisted_3 = {
  class: "line",
  ref: "line"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "line__wrapper" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "theme-info" }
const _hoisted_7 = {
  class: "ps__wrapper",
  ref: "wrapperScrollbar"
}
const _hoisted_8 = { class: "memorial-text__image" }
const _hoisted_9 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_perfect_scrollbar = _resolveComponent("perfect-scrollbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.options)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("h2", { ref: "title" }, _toDisplayString(_ctx.author), 513),
          _createElementVNode("div", _hoisted_3, _hoisted_5, 512),
          _createElementVNode("h3", { ref: "subTitle" }, _toDisplayString(_ctx.role), 513),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.visitorThemeInfo), 1),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_perfect_scrollbar, {
              ref: "scrollbar",
              innerHTML: _ctx.content
            }, null, 8, ["innerHTML"])
          ], 512)
        ], 512))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("img", {
        src: _ctx.image,
        alt: ""
      }, null, 8, _hoisted_9)
    ])
  ]))
}